import type { ThemeConfig } from 'antd';

export const themeTokens = {
  color: {
    primary: '#4f46e5',
    primaryLight: '#818cf8',
    primaryDark: '#4338ca',
    success: '#10b981',
    warning: '#f59e0b',
    error: '#ef4444',
    info: '#3b82f6',
    background: '#f8fafc',
    surface: '#ffffff',
    border: '#e2e8f0',
    text: '#0f172a',
    textSecondary: '#64748b',
    textTertiary: '#94a3b8'
  },
  borderRadius: {
    sm: 6,
    md: 10,
    lg: 14,
    xl: 18
  },
  spacing: {
    xs: 4,
    sm: 8,
    md: 16,
    lg: 24,
    xl: 32
  },
  shadow: {
    sm: '0 1px 2px 0 rgba(15, 23, 42, 0.05)',
    md: '0 4px 6px -1px rgba(15, 23, 42, 0.08), 0 2px 4px -1px rgba(15, 23, 42, 0.04)',
    lg: '0 10px 15px -3px rgba(15, 23, 42, 0.08), 0 4px 6px -2px rgba(15, 23, 42, 0.04)',
    xl: '0 20px 25px -5px rgba(15, 23, 42, 0.08), 0 10px 10px -5px rgba(15, 23, 42, 0.04)'
  }
};

export const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: themeTokens.color.primary,
    colorSuccess: themeTokens.color.success,
    colorWarning: themeTokens.color.warning,
    colorError: themeTokens.color.error,
    colorInfo: themeTokens.color.info,
    colorBgLayout: themeTokens.color.background,
    colorBgContainer: themeTokens.color.surface,
    colorBorder: themeTokens.color.border,
    colorText: themeTokens.color.text,
    colorTextSecondary: themeTokens.color.textSecondary,
    borderRadius: themeTokens.borderRadius.md,
    borderRadiusSM: themeTokens.borderRadius.sm,
    borderRadiusLG: themeTokens.borderRadius.lg,
    boxShadow: themeTokens.shadow.md,
    boxShadowSecondary: themeTokens.shadow.lg,
    fontSize: 14,
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif',
    controlHeight: 36,
    controlHeightLG: 42,
    controlHeightSM: 30
  },
  components: {
    Layout: {
      headerHeight: 64,
      headerPadding: '0 24px'
    },
    Menu: {
      itemSelectedBg: 'rgba(79, 70, 229, 0.08)',
      itemSelectedColor: themeTokens.color.primary,
      itemHoverBg: 'rgba(79, 70, 229, 0.04)',
      itemHoverColor: themeTokens.color.primary,
      itemColor: themeTokens.color.textSecondary,
      itemActiveBg: 'rgba(79, 70, 229, 0.12)',
      itemBorderRadius: 8,
      collapsedWidth: 72
    },
    Card: {
      borderRadiusLG: themeTokens.borderRadius.lg,
      boxShadow: themeTokens.shadow.sm,
      colorBorderSecondary: themeTokens.color.border
    },
    Button: {
      borderRadius: themeTokens.borderRadius.md,
      colorPrimaryHover: themeTokens.color.primaryDark,
      colorPrimaryActive: themeTokens.color.primaryDark
    },
    Input: {
      borderRadius: themeTokens.borderRadius.md,
      paddingInline: 14,
      paddingBlock: 8
    },
    Select: {
      borderRadius: themeTokens.borderRadius.md,
      controlHeight: 36
    },
    Table: {
      borderRadius: themeTokens.borderRadius.lg,
      headerBorderRadius: themeTokens.borderRadius.lg,
      headerBg: themeTokens.color.background,
      headerColor: themeTokens.color.text,
      rowHoverBg: 'rgba(79, 70, 229, 0.03)'
    },
    Modal: {
      borderRadiusLG: themeTokens.borderRadius.xl,
      titleFontSize: 18
    },
    Dropdown: {
      borderRadiusLG: themeTokens.borderRadius.lg,
      controlItemBgHover: 'rgba(79, 70, 229, 0.04)'
    },
    Tag: {
      borderRadiusSM: 4
    },
    Statistic: {
      contentFontSize: 28,
      titleFontSize: 14
    }
  }
};
